import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconPointer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="round-filled-radius-2-stroke-1.5-IconPointer"><Path d="M11.1875 9.12333H15.9853C18.3406 9.12333 20.25 11.0859 20.25 13.5069V14.1416C20.25 18.4817 16.8271 22 12.6047 22C9.76611 22 7.16121 20.3835 5.83916 17.8016L2.80581 11.8777C2.71598 11.7022 2.73582 11.4891 2.85641 11.3341L3.45831 10.5608C4.19399 9.61558 5.53587 9.46232 6.45548 10.2185L7.45583 11.0411V3.91781C7.45583 2.85863 8.29119 2 9.32165 2C10.3521 2 11.1875 2.85863 11.1875 3.91781V9.12333Z" fill="currentColor"/></CentralIconBase>;
});

export default IconPointer;
